import { createContext, useContext } from "react";

type ThemeType = "light" | "dark";

export const THEME_KEY = "app_theme";
export const BRAND_COLOR_KEY = "app_brand_color";

export type ThemeContextShape = {
  theme: ThemeType;
  setTheme: (t: ThemeType) => void;
  toggleTheme: () => void;
};

export const ThemeContext = createContext<ThemeContextShape>({
  theme: "light",
  setTheme: () => {},
  toggleTheme: () => {},
});

export const useAppTheme = () => useContext(ThemeContext);
